// fallow-ignore-file unused-file -- loaded from layout/theme.liquid through Shopify's asset_url filter
'use strict';

function initKlaviyoConsentLoader(options) {
  var browserWindow = options.window;
  var browserDocument = options.document;
  var companyId = options.companyId;
  var product = options.product;
  var hasIntent = false;
  var loadStarted = false;
  var productViewSent = false;

  function hasMarketingConsent() {
    return Boolean(browserWindow.Cookiebot?.consent?.marketing);
  }

  function sendProductView() {
    if (!product || productViewSent) return;
    productViewSent = true;
    browserWindow._learnq = browserWindow._learnq || [];
    browserWindow._learnq.push(['track', 'Viewed Product', product]);
  }

  function loadWhenAllowed() {
    if (loadStarted || !hasIntent || !hasMarketingConsent()) return;
    loadStarted = true;

    var script = browserDocument.createElement('script');
    script.async = true;
    script.src =
      'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' +
      encodeURIComponent(companyId);
    script.addEventListener('load', sendProductView);
    browserDocument.head.appendChild(script);
  }

  function recordIntent() {
    hasIntent = true;
    loadWhenAllowed();
  }

  browserDocument.addEventListener('pointerdown', recordIntent, { once: true, passive: true });
  browserDocument.addEventListener('touchstart', recordIntent, { once: true, passive: true });
  browserDocument.addEventListener('keydown', recordIntent, { once: true });
  browserWindow.addEventListener('CookiebotOnConsentReady', loadWhenAllowed);
  browserWindow.addEventListener('CookiebotOnAccept', loadWhenAllowed);
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initKlaviyoConsentLoader };
} else {
  var configElement = document.getElementById('florafy-klaviyo-loader-config');
  if (configElement) {
    var config = JSON.parse(configElement.textContent);
    initKlaviyoConsentLoader({
      window: window,
      document: document,
      companyId: config.companyId,
      product: config.product,
    });
  }
}
